import { Helmet } from "react-helmet-async";

const SITE = "https://muthaparas.com";

const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "ClothingStore",
  name: "Mutha Paras & Co.",
  image: `${SITE}/brand/og-card.png`,
  "@id": `${SITE}/`,
  url: `${SITE}/`,
  telephone: "+91-7624853840",
  priceRange: "$$",
  foundingDate: "1974",
  description:
    "Lining fabric manufacturer and wholesaler in Chickpet, Bangalore since 1974. Nine qualities of cambric, pure cotton and American Crepe lining in 336 lining shades and 446 American Crepe shades, with bulk stock ready to dispatch across India.",
  hasMap: "https://maps.app.goo.gl/BfuGnnPuXTabFs1B8",
  currenciesAccepted: "INR",
  areaServed: { "@type": "Country", name: "India" },
  knowsAbout: [
    "Lining fabric",
    "Cambric lining",
    "American Crepe lining",
    "Pure cotton lining",
    "Shade matching",
    "Wholesale fabric supply",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Kochaar Muthas Enclave No. 28, Venkusahuji Lane, Chickpet Cross",
    addressLocality: "Bangalore",
    addressRegion: "Karnataka",
    postalCode: "560053",
    addressCountry: "IN",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "10:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Sunday",
      opens: "00:00",
      closes: "00:00",
    },
  ],
  publicAccess: true,
  sameAs: [
    "https://instagram.com/theliningstoreindia",
    "https://instagram.com/muthaparas",
  ],
};

export default function SEO({
  title,
  description,
  path = "/",
  jsonLd = null,
  image = `${SITE}/brand/og-card.png`,
}) {
  const canonical = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Mutha Paras & Co." />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {/* LocalBusiness JSON-LD on every page */}
      <script type="application/ld+json">
        {JSON.stringify(LOCAL_BUSINESS_LD)}
      </script>
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export { SITE, LOCAL_BUSINESS_LD };
